<div class="p-4 md:p-8 bg-gray-50 dark:bg-gray-900/50 h-full overflow-y-auto  ">
  <div class="bg-white dark:bg-gray-700/50 rounded-xl shadow-sm  overflow-hidden">

    <div class="p-6 ">
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">

        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-lg bg-yellow-50 dark:bg-yellow-900/50 flex items-center justify-center">
            <img
              src="data:image/png;base64,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"
              class="w-6 h-6 object-contain" alt="icon">
          </div>
          <div>
            <h2 class="text-xl font-bold text-gray-800 dark:text-gray-200">รายการใช้บริการจอด EV</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">จัดการและตรวจสอบรายการชาร์จ</p>
          </div>
        </div>

        <div class="flex flex-col gap-3 items-end">
          <div class="flex flex-col md:flex-row gap-3 items-end md:items-center">
            <button (click)="onRefresh()"
              class="cursor-pointer bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400 p-2.5 rounded-lg transition-colors shadow-sm flex items-center justify-center"
              title="รีเฟรชข้อมูล">
              <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </button>

            <!-- <div
              class="flex items-center gap-2 bg-gray-50 dark:bg-gray-800 p-1 rounded-lg border border-gray-200 dark:border-gray-700">
              <input type="date"
                class="bg-transparent border-none text-gray-600 dark:text-gray-300 text-sm focus:ring-0 p-2 cursor-pointer"
                [(ngModel)]="startDate" title="วันที่เริ่มต้น">
              <span class="text-gray-400 dark:text-gray-500">-</span>
              <input type="date"
                class="bg-transparent border-none text-gray-600 dark:text-gray-300 text-sm focus:ring-0 p-2 cursor-pointer"
                [(ngModel)]="endDate" title="วันที่สิ้นสุด">
            </div> -->

            <div class="relative w-[250px]">
              <app-input [placeholder]="'ค้นหา ทะเบียน, สถานที่, ช่องจอด...'" [type]="'text'" [disabledValidate]="true"
                [valueIn]="searchText" (valueOut)="onSearch($event)"
                class="block w-full dark:text-gray-400"></app-input>
            </div>
            <!-- 
            <button (click)="onClickSearch()"
              class="cursor-pointer bg-(--bg-theme-color) hover:bg-(--bg-theme-color-btn-hover) text-white p-2.5 rounded-lg transition-colors shadow-sm flex items-center justify-center">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="relative overflow-x-auto">
      <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead
          class="text-xs text-gray-700 dark:text-gray-300 uppercase bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <tr>
            <th scope="col" class="px-6 py-4 font-semibold text-center w-12">#</th>
            <th scope="col" class="px-6 py-4 font-semibold text-center">ID</th>
            <th scope="col" class="px-6 py-4 font-semibold">ป้ายทะเบียน</th>
            <th scope="col" class="px-6 py-4 font-semibold text-center">ช่องชาร์จ</th>
            <th scope="col" class="px-6 py-4 font-semibold">วันที่เข้าจอด</th>
            <th scope="col" class="px-6 py-4 font-semibold">เวลาจอด</th>
            <th scope="col" class="px-6 py-4 font-semibold">สถานที่ชาร์จ</th>
            <th scope="col" class="px-6 py-4 font-semibold text-right">ราคา</th>
            <th scope="col" class="px-6 py-4 font-semibold text-center">สถานะ</th>
            <th scope="col" class="px-6 py-4 font-semibold text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
          <tr *ngFor="let item of filteredAndPaginatedData; let i = index"
            class="bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer group">

            <td class="px-6 py-4 text-center text-gray-400 dark:text-gray-500">
              {{ (currentPage - 1) * pageSize + i + 1 }}
            </td>
            <td class="px-6 py-4 text-center font-medium text-gray-900 dark:text-gray-100">{{ item.id }}</td>
            <td class="px-6 py-4">
              <div class="font-medium text-gray-900 dark:text-gray-100">{{ item.licensePlate }}</div>
            </td>
            <td class="px-6 py-4 text-center">
              <span
                class="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 py-1 px-2 rounded text-xs font-medium">{{
                item.spaceCode }}</span>
            </td>
            <td class="px-6 py-4 text-gray-600 dark:text-gray-300">
              {{ item.enterAt | date : "dd/MM/yyyy HH:mm" }}
            </td>
            <td class="px-6 py-4">
              <div class="flex items-center gap-1 text-gray-600 dark:text-gray-300">
                <span class="font-medium">{{ calHours(item.totalTime).hours }}</span> <span class="text-xs">ชม.</span>
                <span class="font-medium">{{ calHours(item.totalTime).minutes }}</span> <span
                  class="text-xs">นาที</span>
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ item.siteName }}</div>
              <div class="text-xs text-gray-500 dark:text-gray-400">{{ item.siteEv }}</div>
            </td>
            <td class="px-6 py-4 text-right font-medium text-gray-900 dark:text-gray-100">
              {{ item.price | number:'1.2-2' }}
            </td>
            <td class="px-6 py-4 text-center">
              <span
                class="px-2.5 py-1 rounded-full text-xs font-medium inline-flex items-center justify-center min-w-[80px]"
                [ngClass]="{
                                'text-yellow-700 dark:text-yellow-500 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-900/50': item.status == 1,
                                'text-blue-700 dark:text-blue-500 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-900/50': item.status == 2,
                                'text-green-700 dark:text-green-500 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-900/50': item.status == 3,
                                'text-red-700 dark:text-red-500 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-900/50': item.status == 4,
                                'text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600': item.status == 0
                            }">
                {{
                item.status == 1 ? "กำลังชาร์จ" :
                item.status == 2 ? "อนุมัติ" :
                item.status == 3 ? "เสร็จสิ้น" :
                "จอดอยู่"
                }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <div class="flex items-center justify-center gap-2">
                <button (click)="onClickEditEvVehicleDetail(item)"
                  class="text-green-600 dark:text-green-400 hover:text-green-800 dark:hover:text-green-300 p-1.5 hover:bg-green-50 dark:hover:bg-green-900/30 rounded-lg transition-colors border border-transparent hover:border-green-100 dark:hover:border-green-900/50"
                  title="แก้ไข">
                  <span class="text-xs font-medium">แก้ไข</span>
                </button>
                <button (click)="onClickHistoryEvVehicleDetail(item)"
                  class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 p-1.5 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg transition-colors border border-transparent hover:border-blue-100 dark:hover:border-blue-900/50"
                  title="ดูรายละเอียด">
                  <span class="text-xs font-medium">รายละเอียด</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="filteredAndPaginatedData.length === 0">
            <td colspan="10"
              class="px-6 py-10 text-center text-gray-400 dark:text-gray-500 bg-gray-50/50 dark:bg-gray-800/50">
              ไม่พบข้อมูล
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="flex flex-col md:flex-row items-center justify-between p-6 border-t border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">
      <div class="flex items-center gap-2 mb-4 md:mb-0 text-sm text-gray-500 dark:text-gray-400">
        <div class="flex items-center gap-2">
          <span>แสดง</span>
          <select (change)="onPageSizeChange($event)" [value]="pageSize"
            class="border border-gray-300 dark:border-gray-600 rounded-lg text-sm text-gray-700 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 py-1 pl-2 pr-6 cursor-pointer bg-white dark:bg-gray-700">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
          </select>
          <span>รายการ</span>
        </div>
        <div class="hidden sm:block w-px h-4 bg-gray-300 dark:bg-gray-600 mx-2"></div>
        <div>
          Page <span class="font-semibold text-gray-900 dark:text-gray-100">{{ currentPage }}</span> of <span
            class="font-semibold text-gray-900 dark:text-gray-100">{{ totalPages }}</span>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="cursor-pointer px-4 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-(--bg-theme-color-btn-hover) hover:border-(--bg-theme-color-btn-hover) hover:text-white dark:hover:text-white hover:scale-108 hover:shadow-lg hover:shadow-(--bg-theme-color-btn-hover) transition-all 
                          disabled:hover:bg-white dark:disabled:hover:bg-gray-800 disabled:hover:border-gray-200 dark:disabled:hover:border-gray-700 disabled:hover:text-gray-400 dark:disabled:hover:text-gray-500 disabled:hover:scale-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:text-gray-400 dark:disabled:text-gray-500 transition-all text-sm font-medium text-gray-600 dark:text-gray-300">
          ก่อนหน้า
        </button>

        <div class="flex gap-1">
          <button *ngFor="let page of pagesArray" (click)="setPage(page)"
            [class.bg-(--bg-theme-color-btn-soft)]="currentPage === page"
            [class.text-(--bg-theme-color-text)]="currentPage === page" [class.font-bold]="currentPage === page"
            [class.border-(--bg-theme-color-btn)]="currentPage === page" [class.border-gray-200]="currentPage !== page"
            [class.dark:border-gray-700]="currentPage !== page" [class.bg-white]="currentPage !== page"
            [class.dark:bg-gray-800]="currentPage !== page" [class.text-gray-400]="currentPage !== page"
            [class.dark:text-gray-500]="currentPage !== page" class="w-10 h-10 flex items-center justify-center rounded-lg border-1 text-sm 
                              hover:bg-(--bg-theme-color-btn-hover) hover:text-white hover:border-(--bg-theme-color-btn-hover) hover:shadow-lg hover:shadow-(--bg-theme-color-btn-hover) hover:scale-108  
                              transition-all">
            {{ page }}
          </button>
        </div>

        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
          class="cursor-pointer px-4 py-2.5 rounded-lg bg-(--bg-theme-color-btn-next) hover:bg-(--bg-theme-color-btn-hover) hover:scale-108 hover:shadow-lg hover:shadow-(--bg-theme-color-btn-hover) transition-all 
                      disabled:hover:bg-white disabled:hover:scale-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:text-gray-400 disabled:text-yellow-800 transition-all text-sm font-medium text-white">
          ถัดไป
        </button>
      </div>
    </div>
  </div>
</div>

<!--------------------------------------------------- Modal ---------------------------------------->
<!----------------------------------- Modal loading ---------------------------------->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!----------------------------------- Modal EvVehicleDetail ---------------------------------->
<div *ngIf="isModalEvVehicleDetail"
  class="fixed z-50 inset-0 overflow-y-auto bg-black/70 backdrop-blur-sm flex justify-center items-center">
  <div class="flex flex-col items-center justify-center bg-white dark:bg-gray-800 w-full max-w-md"
    style="border-radius: 24px">
    <div
      class="flex items-center justify-center border-b border-gray-200 dark:border-gray-700 w-full p-4 pt-6 relative">
      <p class="text-lg font-bold text-gray-800 dark:text-gray-200">ข้อมูลการจอด EV charger</p>
      <!-- ปุ่มปิด -->
      <div
        class="w-4 h-4 absolute top-5 right-5 cursor-pointer text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
        (click)="onCloseModalEvVehicleDetail()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center space-y-2 w-full p-4 px-6">
      <div class="w-full">
        <p class="text-gray-800 dark:text-gray-200">ชื่อพื้นที่</p>
        <app-input [valueIn]="spaceName" [disabledValidate]="true" [readOnly]="true" [placeholder]="'ชื่อพื้นที่'"
          [type]="'text'"></app-input>
      </div>
      <div class="w-full">
        <p class="text-gray-800 dark:text-gray-200">รหัส SPACE</p>
        <app-input [valueIn]="siteEvName" [disabledValidate]="true" [readOnly]="true" [placeholder]="'รหัส SPACE'"
          [type]="'text'"></app-input>
      </div>
      <div class="w-full">
        <p class="text-gray-800 dark:text-gray-200">ทะเบียน</p>
        <input [(ngModel)]="licensePlate" type="text"
          class="w-full border dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 px-3 py-2 rounded-md" />
      </div>
      <div class="w-full">
        <p class="text-gray-800 dark:text-gray-200">รหัส HistoryUID</p>
        <app-input [valueIn]="historyUid" [disabledValidate]="true" [readOnly]="true" [placeholder]="'รหัส SPACE'"
          [type]="'text'"></app-input>
      </div>
    </div>
    <div class="flex items-center justify-center w-full mt-2">
      <button class="cursor-pointer bg-yellow-300 text-gray-700 p-2 py-3 w-full rounded-b-lg"
        (click)="onConfirmSendManualPlateCorrection(licensePlate)">
        ยืนยัน
      </button>
    </div>
  </div>
</div>

<!----------------------------------- Modal History ---------------------------------->
<div *ngIf="isModalEvVehicleHistory"
  class="fixed z-50 inset-0 overflow-y-auto bg-black/70 backdrop-blur-sm flex justify-center items-center"
  style="padding: 0% 4%;">
  <div class="flex flex-col items-center justify-center bg-white dark:bg-gray-800 w-full" style="border-radius: 24px">
    <div
      class="flex items-center justify-center border-b border-gray-200 dark:border-gray-700 w-full p-4 pt-6 relative">
      <p class="text-lg font-bold text-gray-800 dark:text-gray-200">ดูรายละเอียด EV charger</p>
      <!-- ปุ่มปิด -->
      <div
        class="w-4 h-4 absolute top-5 right-5 cursor-pointer text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
        (click)="onCloseModalEvVehicleHistory()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    </div>
    <div class="flex flex-col items-center justify-center space-y-2 w-full p-4 px-6">
      <app-table class="w-full" [data]="evVehicleHistoryCustom" [headers]="evVehicleHistoryColumns"
        [columns]="evVehicleHistoryWhere" [pagination]="false" [height]="580"></app-table>
    </div>
    <div class="flex items-center justify-center w-full mt-2">
      <button class="bg-yellow-300 text-gray-700 p-2 py-3 w-full rounded-b-lg" (click)="onCloseModalEvVehicleHistory()">
        ปิด
      </button>
    </div>
  </div>
</div>